import React from "react";
import NavBar from "components/tabs/TabsHolder";
import ProfitSettings from "features/settings/subFeatures/settingsTabs/dealDefault/ProfitSettings";
import CommissionSettings from "features/settings/subFeatures/settingsTabs/dealDefault/CommissionSetting";
import TaxDefaults from "features/settings/subFeatures/settingsTabs/dealDefault/TaxDefaults";
import shallow from "zustand/shallow";
import useCurrentDealStore from "stores/DealStore";
import { Col, Row } from "reactstrap";
import LeaseSettings from "../../../../settings/subFeatures/settingsTabs/dealDefault/LeaseSetting";
import useCurrentSaleStore from "../../../../../stores/SaleStore";

/**
 * Tax, profit, and commission settings for the deal detail page.
 * This tab modifies the settings for a particular deal.
 *
 * @component
 */
const DealPageDealSettings = () => {
	// Extract state and state update functions from the store
	const {
		profitSettings,
		editProfitSettings,
		editProfitSettingsValue,
		commissionSettings,
		editCommissionSettings,
		editCommissionSettingsValue,
		taxDefaults,
		editTaxDefaults,
		editTaxDefaultsValue,
	} = useCurrentDealStore(
		(state) => ({
			profitSettings: state.deal.dealSettings.profitSettings,
			editProfitSettings: state.editProfitSettings,
			editProfitSettingsValue: state.editProfitSettingsValue,
			commissionSettings: state.deal.dealSettings.commissionSettings,
			editCommissionSettings: state.editCommissionSettings,
			editCommissionSettingsValue: state.editCommissionSettingsValue,
			taxDefaults: state.deal.dealSettings.taxDefaults,
			editTaxDefaults: state.editTaxDefaults,
			editTaxDefaultsValue: state.editTaxDefaultsValue,
		}),
		shallow
	);
	const { saleType } = useCurrentSaleStore((state) => state, shallow);
	// Define the components for each tab

	// Define the tabs
	const tabs = ["Tax", "Profit", "Commission"];
	if (saleType > 4) tabs.push("Lease");

	const tabComponents = [
		<Row className="mx-0 pb-2 justify-content-center">
			<TaxDefaults
				isDeal={true}
				taxDefaults={taxDefaults}
				editTaxDefaults={editTaxDefaults}
				editTaxDefaultsValue={editTaxDefaultsValue}
			/>
			,
		</Row>,
		<ProfitSettings
			isDeal={true}
			profitSettings={profitSettings}
			editProfitSettings={editProfitSettings}
			editProfitSettingsValue={editProfitSettingsValue}
		/>,
		<Row className="mx-0 pb-2 justify-content-center">
			<CommissionSettings
				isDeal={true}
				commissionSettings={commissionSettings}
				editCommissionSettings={editCommissionSettings}
				editCommissionSettingsValue={editCommissionSettingsValue}
			/>
			,
		</Row>,
		<Row className="mx-0 pb-2 justify-content-center">
			<LeaseSettings isDeal={true} />
		</Row>,
	];

	return (
		<Col>
			<NavBar
				navClass="nav-pills-primary justify-content-center nav nav-pills"
				tabs={tabs}
				tabComponents={tabComponents}
			/>
		</Col>
	);
};

export default DealPageDealSettings;
